import React from "react";
import moment from "moment";
import NotificationSystem from "react-notification-system";
import SearchPanel from './search-panel'
import {
    apiActions,
    alertActions
} from "../../_actions";
import { appConstants } from "../../_constants";
import {appHelpers} from "../../_helpers";
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import { commonService } from "../../_services";
import {Card, CardBody, Progress, Row, Col} from "reactstrap";
import {connect} from "react-redux";

const ViewHeader = () => (
    <div className="view-header d-flex align-items-center">
        <header className="text-white">
            <h1 className="h5 title text-uppercase">Elastic Search Sync</h1>
            <p className="mb-0 subtitle text-nowrap">
                Sync elastic search with database
            </p>
        </header>
    </div>
);

const ViewContent = ({ children }) => (
    <div className="view-content view-components">{children}</div>
);

class ElasticSearchSync extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: new Date(),
            endDate: new Date(),
            dateType: [{Id: 1, Name: "Flight Date"},
                      {Id: 2, Name: "Submitted Date"}],
            selectedDateType: false,
            totalDBCount: 0,
            totalESCount: 0,
            variance: 0,
            contentError: false, //Errors that affect content on the page
            componentError: false, //Errors generated within the component
            componentErrorMessages: [],
            error: false, //Error state mutable via Redux
            success: false, //Success message mutable via Redux
            notification: {
                // title: 'Default Title',
                message: "Default Message",
                level: "success",
                dismissible: true
            },
        };

        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        this.search();
    }

    notify = (message, level) => {
        let notification = this.state.notification;
        notification['message'] = message;
        notification['level'] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(notification);
    };

    onRemove = (notification) => {
        if (this._lastNotificationAdded && notification.uid === this._lastNotificationAdded.uid) {
            this._lastNotificationAdded = null;
        }
    };

    handleSelectChange = (payload, attribute, stateAttribute) => {
        let currState = this.state;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[stateAttribute] = false;
        currState[stateAttribute] = payload ? payload[attribute] : ""; //Cater for setting up data and clearing data
        this.setState(currState);
    };

    validateInput = () => {
        let _errs_ = [];
        let formValid = true;

        if (this.state.selectedDateType === false) {
            _errs_["dateType"] = "Please select a date type";
            formValid = false;
        }
        this.setState({ componentErrorMessages: _errs_ });
        return formValid;
    };


    search = () => {
        const {dispatch} = this.props;
        dispatch(apiActions.startRequest());
        commonService.getDataCount()
            .then(res => {
                dispatch(apiActions.endRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        // totalDBCount: Number(response.data.slice(16, 22)),
                        totalDBCount: response.data.TotalDbcount,
                        // totalESCount: Number(response.data.slice(38, 44)),
                        totalESCount: response.data.TotalEsCount,
                        variance:  response.data.TotalDbcount - response.data.TotalEsCount
                        // variance:  Number(response.data.slice(16, 22)) - Number(response.data.slice(38, 44))
                    })
                }  else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(
                        alertActions.error(
                            appHelpers.interpretErrorResponseAlt2(res.response)
                        )
                    );
                    dispatch(apiActions.endRequest());
                }

            })

    };

    indexManifest = () => {
        let {startDate, endDate, selectedDateType} = this.state;
        const {dispatch} = this.props;

        if (this.validateInput()) {
            dispatch(apiActions.startRequest());

            const payload = {
                sdate:  moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
                edate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59",
                dateType: selectedDateType
            };

            commonService.indexManifest(payload)
                .then(res => {
                    let response = res.response;
                    dispatch(apiActions.endRequest());
                    if(res.status === appConstants.SUCCESS_RESPONSE) {
                        this.setState({
                            totalDBCount: response.data.TotalDbcount,
                            totalESCount: response.data.TotalEsCount,
                            variance: response.data.TotalDbcount - response.data.TotalEsCount
                        })
                    }
                    else if (res.status === appConstants.ERROR_RESPONSE) {
                        this.notify(res.response, appConstants.NOTIFY_ERROR);
                    }
                })
        }


    };


    render() {
        const { requesting, pageRequesting } = this.props;
        const { totalDBCount, totalESCount, variance, contentError, dateType, selectedDateType, componentErrorMessages} = this.state;
        return (
            <div className="view">
                <ViewHeader />
                <ViewContent>
                    <Card className="mb-4">
                        {/*Progress bar for Pending API Request*/}
                        {(pageRequesting || requesting) && !pageRequesting && (
                            <Progress
                                striped
                                animated
                                color="success"
                                value={100}
                                className="mb-2"
                            />
                        )}
                        {/*Display loader when component content is dependent on Data from API*/}
                        {!contentError && pageRequesting && <PageLoading />}

                        {/*Display error when component fail to get Data from API*/}
                        {contentError && <PageError error={this.state.contentError} />}

                        {/*Display component content when Data is gotten from API*/}

                        {!contentError && !pageRequesting && (
                            <CardBody>
                                <h6 className="mb-4 text-uppercase">Search Panel</h6>
                                <SearchPanel
                                    onSearch={this.indexManifest}
                                    startDateChange={startDate => this.setState({ startDate })}
                                    endDateChange={endDate => this.setState({ endDate })}
                                    dateType={dateType}
                                    selectedDateType={selectedDateType}
                                    componentErrorMessages={componentErrorMessages}
                                    onDateTypeChange={payload =>
                                        this.handleSelectChange(payload, "Id", "selectedDateType")}
                                />

                                <Row className={"text-center"} style={{marginTop: "30px"}}>
                                    <Col sm={4}>
                                        <h6>Total DB Count</h6>
                                        <h1>{totalDBCount}</h1>
                                    </Col>
                                    <Col sm={4}>
                                        <h6>Total ES Count</h6>
                                        <h1>{totalESCount}</h1>
                                    </Col>
                                    <Col sm={4}>
                                        <h6>Variance</h6>
                                        <h1>{variance}</h1>
                                    </Col>
                                </Row>
                            </CardBody>
                        )}
                        <NotificationSystem ref="notificationSystem" />
                    </Card>
                </ViewContent>
            </div>
                        );
    }
}

function mapStateToProps(state) {
    return {
        requesting: state.api.requesting,
        pageRequesting: state.api.pageRequesting
    };
}

export default connect(mapStateToProps)(ElasticSearchSync);


// WEBPACK FOOTER //
// ./src/views/elastic-search-sync/index.js